<template>
  <v-app :class="[rounteName,{ 'is-product-menu': isProductMenu }]">
    <v-app-bar color="transparent" app dark fixed>
      <v-container>
        <v-row class="align-center">
          <v-col cols="12" sm="12" md="2" class="col-logo" :class="[{ mobile: isMobileMenu }]">
            <v-app-bar-nav-icon v-on:click="showHideMenu"></v-app-bar-nav-icon>
            <router-link to="/">
              <div cols="12" class="riiqo-logo"></div>
            </router-link>
          </v-col>
          <v-col cols="12" sm="12" md="10" class="col-nav" :class="[{ show: isMobileMenu }]">
            <ul class="nav">
              <li class="nav-item" v-on-clickaway="menuClickAway">
                <a class="nav-link nav-link--dropdown active" href="#" v-on:click="productMenu">Products</a>
                <div class="products-menu">
                  <ul>
                    <li>
                      <router-link to="customer" class="nav-link" @click.native="resetNav">
                        <span class="_customer"></span> Customer
                      </router-link>
                    </li>
                    <li>
                      <router-link to="chat" class="nav-link" @click.native="resetNav">
                        <span class="_interchange"></span> Interchange
                      </router-link>
                    </li>
                    <li>
                      <router-link to="analytics" class="nav-link" @click.native="resetNav">
                        <span class="_analytics"></span> Analytics
                      </router-link>
                    </li>
                    <li>
                      <router-link to="storage" class="nav-link" @click.native="resetNav">
                        <span class="_storage"></span> Storage
                      </router-link>
                    </li>
                    <li>
                      <router-link to="preferences" class="nav-link" @click.native="resetNav">
                        <span class="_settings"></span> Preferences
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-item">
                <router-link to="integrations" class="nav-link" @click.native="resetNav">Integrations</router-link>
              </li>
              <li class="nav-item">
                <router-link to="contact" class="nav-link" @click.native="resetNav">Contact</router-link>
              </li>
              <li class="nav-item nav-item--btn">
                <router-link to="demo" class="btn" @click.native="resetNav">Sign Up</router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://app.riiqo.com/login" target="_blank">Login</a>
              </li>
            </ul>
            <div class="nav-productmenu-mobile">
              <button class="btn-back" @click.native="isProductMenu=false">
                <span class="_linearrowleft"></span> Products
              </button>
              <ul>
                <li>
                  <router-link to="customer" class="nav-link" @click.native="resetNav">
                    <span class="_customer"></span> Customer
                  </router-link>
                </li>
                <li>
                  <router-link to="chat" class="nav-link" @click.native="resetNav">
                    <span class="_interchange"></span> Interchange
                  </router-link>
                </li>
                <li>
                  <router-link to="analytics" class="nav-link" @click.native="resetNav">
                    <span class="_analytics"></span> Analytics
                  </router-link>
                </li>
                <li>
                  <router-link to="storage" class="nav-link" @click.native="resetNav">
                    <span class="_storage"></span> Storage
                  </router-link>
                </li>
                <li>
                  <router-link to="preferences" class="nav-link" @click.native="resetNav">
                    <span class="_settings"></span> Preferences
                  </router-link>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <router-view></router-view>

    <v-footer
      padless>
      <v-container>
        <v-row>
          <v-col cols="12" sm="3" class="col-logo">
            <!-- <div class="riiqo-logo"></div> -->
            <span class="_riiqo"></span>
          </v-col>
          <v-col cols="12" sm="3" lg="2" class="col-menu mod-menu">
            <h5 class="mod-menu__title">Products</h5>
            <ul class="mod-menu__list">
              <li>
                <router-link to="customer" @click.native="isProductMenu=false">Customer</router-link>
              </li>
              <li>
                <router-link to="chat" @click.native="isProductMenu=false">Chat</router-link>
              </li>
              <li>
                <router-link to="storage" @click.native="isProductMenu=false">Storage</router-link>
              </li>
              <li>
                <router-link to="analytics" @click.native="isProductMenu=false">Analytics</router-link>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" sm="3" lg="2" class="col-menu mod-menu">
            <h5 class="mod-menu__title">Support</h5>
            <ul class="mod-menu__list">
              <li><router-link to="contact">Create Account</router-link></li>
              <li><router-link to="contact">Pricing</router-link></li>
              <li><router-link to="contact">Contact</router-link></li>
            </ul>
          </v-col>
          <v-col cols="12" sm="3" lg="2" class="col-menu col-menu-resources mod-menu">
            <h5 class="mod-menu__title">Resources</h5>
            <ul class="mod-menu__list">
              <li>
                <router-link to="privacy" @click.native="resetNav">Privacy Policy</router-link>
              </li>
              <li>
                <router-link to="terms-conditions" @click.native="resetNav">Terms &amp; Conditions</router-link>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" lg="3" class="col-getstarted">
            <router-link to="contact" class="btn btn-getstarted">Get Started</router-link>
            <a href="tel:3854481008" class="tel">(385) 448-1008</a>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { bus } from './main';
import { mixin as clickaway } from 'vue-clickaway';
export default {
  name: 'App',
  mixins: [ clickaway ],
  data: () => ({
    rounteName: null,
    isProductMenu: false,
    isMobileMenu: false,
  }),
  mounted() {
    this.rounteName = this.$route.name;
    // Route updater
    bus.$on('update-route', (data) => {
      this.rounteName = data.name;
    });
  },
  methods: {
    menuClickAway () {
      this.isProductMenu = false;
    },
    showHideMenu () {
      if(this.isMobileMenu) {
        this.isMobileMenu = false;
      } else {
        this.isMobileMenu = true;
      }
    },
    productMenu() {
      if(this.isProductMenu) {
        this.isProductMenu = false;
      } else {
        this.isProductMenu = true;
      }
    },
    resetNav() {
      this.isProductMenu = false;
      this.isMobileMenu = false;
    }
  }
};
</script>
<style lang="scss">
@import "./assets/scss/app.scss"
</style>
